import React, { useContext } from "react";
import PropTypes from "prop-types";

// styles
import { HeaderWrapper, HeaderInner, HeaderCloseButton, HeaderCloseButtonText, HeaderCloseIcon } from "./Header.styled";

import { StoreLocatorContext } from "../../../context/Context";

import { allowZooomAndScroll } from "../../../helpers/helpers";

export const Header = ({ children, isMobileApp }) => {
	const { setInitStoreLocator, setParamsRecord, setExitApp } = useContext(StoreLocatorContext);

	// close store locator on AP
	const hideStoreLocator = () => {
		// reset the record when closing the map
		setParamsRecord({});

		// hide the map
		setInitStoreLocator(false);

		// set a value for exiting the store locator
		setExitApp(true);

		// when closing the app remove event listener preventing zoom
		allowZooomAndScroll();

		// resetting the hash value in the url when closing the app
		window.location.hash = "#";
	};

	// check if the app webview useragent "An Post" is loaded
	const anPostAppCheck = () => {
		if (navigator.userAgent.indexOf("An Post") !== -1) {
			return true;
		} else {
			return false;
		}
	};

	return (
		<HeaderWrapper isMobileApp={isMobileApp}>
			<HeaderInner>
				<div>{children}</div>
				<div>
					{anPostAppCheck() ? null : (
						<HeaderCloseButton aria-label="Close map, click button to return to An Post" onClick={() => hideStoreLocator()}>
							<HeaderCloseButtonText>Exit</HeaderCloseButtonText>
							<HeaderCloseIcon></HeaderCloseIcon>
						</HeaderCloseButton>
					)}
				</div>
			</HeaderInner>
		</HeaderWrapper>
	);
};

Header.propTypes = {
	children: PropTypes.object,
	isMobileApp: PropTypes.bool
};
